import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLogin, getUserInfo, removeToken } from '../utils/auth';
import { request } from '../utils/request';
import { config } from '../config';
import styles from './Setting.module.css';

export const Setting: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<any>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (checked) return;
    if (isLogin()) {
      const cached = getUserInfo();
      if (cached) {
        setUserInfo(cached);
        setChecked(true);
        return;
      }
      request(config.USER_URL).then(user => {
        setUserInfo(user);
        setChecked(true);
      }).catch(() => {
        removeToken();
        setChecked(true);
      });
    } else {
      setChecked(true);
    }
  }, [checked]);

  const handleLogout = async () => {
    try {
      await fetch(`${config.API_BASE}${config.LOGOUT_URL}`, { method: 'POST' });
    } catch { /* ignore */ }
    removeToken();
    navigate('/');
  };

  const isLoggedIn = !!userInfo;

  return (
    <div className={styles.page}>
      {/* Header */}
      <header className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate('/')}>
          &#8592;
        </button>
        <h1 className={styles.headerTitle}>设置</h1>
        <span className={styles.headerSpacer} />
      </header>

      <div className={styles.content}>
        {/* Login info */}
        <div className={styles.card}>
          <div className={styles.userInfo}>
            {isLoggedIn ? (
              <>
                <div className={styles.avatar}>
                  {userInfo.avatar ? (
                    <img src={userInfo.avatar} alt="" />
                  ) : (
                    <span>&#128100;</span>
                  )}
                </div>
                <div className={styles.userDetails}>
                  <span className={styles.username}>
                    {userInfo.display_name || userInfo.name || userInfo.email}
                  </span>
                  <span className={styles.email}>{userInfo.email}</span>
                </div>
              </>
            ) : (
              <div className={styles.loginPrompt}>
                <span>未登录</span>
              </div>
            )}
          </div>
        </div>

        {/* Storage space */}
        {isLoggedIn && (
          <div className={styles.card}>
            <div className={styles.storageSection}>
              <div className={styles.storageInfo}>
                <span>存储空间</span>
                <span>300M / 1024M</span>
              </div>
              <div className={styles.progressBar}>
                <div className={styles.progressFill} style={{ width: '29%' }} />
              </div>
              <p className={styles.storageTip}>
                存储空间：1024M（开通会员可享受更多容量及其他权益）
              </p>
            </div>
          </div>
        )}

        {/* Menu items */}
        <div className={`${styles.card} ${styles.clickable}`}>
          <div className={styles.menuItem}>
            <span>我的收藏</span>
            <span className={styles.arrow}>&rsaquo;</span>
          </div>
          {isLoggedIn && (
            <div className={`${styles.menuItem} ${styles.clickable}`} onClick={() => navigate('/profile')}>
              <span>个人信息设置</span>
              <span className={styles.arrow}>&rsaquo;</span>
            </div>
          )}
        </div>

        {/* Logout */}
        {isLoggedIn && (
          <button className={styles.logoutBtn} onClick={handleLogout}>
            退出登录
          </button>
        )}
      </div>

      {/* Footer */}
      <footer className={styles.footer}>
        <span>ICP备案号:</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          闽ICP备2025102433号-1
        </a>
      </footer>
    </div>
  );
};
